import { ShieldAlert, ShoppingBag, Landmark, Compass, FileText, Building2 } from "lucide-react";
import { t } from "@/lib/i18n";

const cat = (key, color, Icon, keywords) => ({
  color,
  Icon,
  keywords,
  get label() { return t(`cat.${key}`); },
  get short() { return t(`cat.${key}.s`); },
});

export const CATEGORIES = {
  fiscalia: cat("fiscalia", "#E5484D", ShieldAlert, "denuncia robo delito policia ministerio publico extorsion violencia police report theft crime plainte vol"),
  profeco: cat("profeco", "#F76B15", ShoppingBag, "queja cobro garantia devolucion tienda proveedor concilianet consumer refund complaint store remboursement"),
  finanzas: cat("finanzas", "#10B981", Landmark, "rfc impuestos factura efirma e.firma declaracion predial tesoreria pagos empresa tax invoice impots"),
  turismo: cat("turismo", "#3B82F6", Compass, "pasaporte visa consulado embajada turista viaje extranjero passport embassy consulate tourist passeport ambassade"),
  registro: cat("registro", "#8B5CF6", FileText, "acta nacimiento matrimonio defuncion curp ine credencial licencia placas birth certificate marriage license id naissance"),
  gobierno: cat("gobierno", "#C9A227", Building2, "municipio ayuntamiento alcaldia permisos uso de suelo constancia residencia city hall permit mairie"),
};

const mod = (key, tone) => ({ tone, get label() { return t(`mod.${key}`); } });

export const MODALITY = {
  online: mod("online", "bg-ac-primary-soft text-ac-primary-ink border-ac-primary-line"),
  presencial: mod("presencial", "bg-ac-surface3 text-ac-text border-ac-line"),
  both: mod("both", "bg-ac-accent-soft text-ac-accent-ink border-ac-accent-line"),
};

export const DEFAULT_CENTER = [19.4326, -99.1332];

export const mapsLink = (o) =>
  `https://www.google.com/maps/dir/?api=1&destination=${o.lat},${o.lng}`;

export const formatKm = (d) =>
  d == null ? "" : d < 1 ? `${Math.round(d * 1000)} m` : `${d.toFixed(d < 10 ? 1 : 0)} km`;
